import { useAppConfiguration } from '@wkda/funnel-components';

/**
 * Returns mileage thresholds for fallback lead page.
 * Sweden (sv-SE) uses thresholds 10x lower than other locales.
 *
 * @param {number} upperThreshold - The upper threshold for the mileage.
 * @param {number} lowerThreshold - The lower threshold for the mileage.
 * @returns {Object} - The mileage threshold for the fallback lead page.
 *
 */

export const useMileageThresholdException = function () {
  let upperThreshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 35000;
  let lowerThreshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2500;
  const {
    locale
  } = useAppConfiguration();
  console.log('locale', locale);
  if (locale === 'sv-SE') {
    return {
      upperThreshold: upperThreshold / 10,
      lowerThreshold: lowerThreshold / 10
    };
  }
  return {
    upperThreshold,
    lowerThreshold
  };
};